<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="totalAmount">
            <span class="totalAmount_title">实发金额</span>
            <span class="moneys">￥{{form.salary}}</span>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>基本信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">店员姓名</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">月份</div>
              <div class="itemNum">{{ formatMonth(form.reportMonth) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">职位</div>
              <div class="itemNum">{{ form.positionName }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>提成工资</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">合计</div>
              <div class="itemNum">￥{{ form.commissionSubtotal }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">劳动业绩</div>
              <div class="itemNum">￥{{ form.workAchAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">劳动提成</div>
              <div class="itemNum">￥{{ form.workDeductAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">销售业绩</div>
              <div class="itemNum">￥{{ form.saleAchAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">销售提成</div>
              <div class="itemNum">￥{{ form.saleDeductAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">免脚补贴</div>
              <div class="itemNum">￥{{ form.noFootSubsidyAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>发放明细</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">合计</div>
              <div class="itemNum">￥{{ form.subsidySubtotal }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">社保补贴</div>
              <div class="itemNum">￥{{form.socialSubsidyAmount}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">应发全勤</div>
              <div class="itemNum">￥{{ form.fullAttendanceAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">工龄</div>
              <div class="itemNum">￥{{ form.workAgeSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">副店长补贴</div>
              <div class="itemNum">￥{{ form.viceShopManagerAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">收银补贴</div>
              <div class="itemNum">￥{{ form.cashierSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">厨师补贴</div>
              <div class="itemNum">￥{{ form.chefSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">店员补贴</div>
              <div class="itemNum">￥{{ form.staffSubsidySubTotal }}</div>
            </div>
            <el-row class="staffSubsidy">
              <el-col :span="12">车费补贴</el-col>
              <el-col :span="12">{{form.fareSubsidyAmount}}</el-col>
              <el-col :span="12">体检补贴</el-col>
              <el-col :span="12">{{form.healthCheckSubsidyAmount}}</el-col>
              <el-col :span="12">工服补贴</el-col>
              <el-col :span="12">{{form.coverallAmount}}</el-col>
              <el-col :span="12">床品补贴</el-col>
              <el-col :span="12">{{form.beddingAmount}}</el-col>
              <el-col :span="12">开业打扫补贴</el-col>
              <el-col :span="12">{{form.openCleanAmount}}</el-col>
              <el-col :span="12">综合补贴</el-col>
              <el-col :span="12">{{form.socialReimburseAmount}}</el-col>
            </el-row>
            <div class="flex-row mb30">
              <div class="itemName">其他补贴</div>
              <div class="itemNum">￥{{ form.otherSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">入职补助</div>
              <div class="itemNum">￥{{ form.guaranteeSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">师带徒奖励</div>
              <div class="itemNum">￥{{ form.teachSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">品质战奖励</div>
              <div class="itemNum">￥{{ form.qualityAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">疫情补贴</div>
              <div class="itemNum">￥{{ form.epidemicSubsidyAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>扣回明细</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">合计</div>
              <div class="itemNum">￥{{ form.reduceDetailSubtotal }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">师带徒考核</div>
              <div class="itemNum">￥{{ form.teachCheckSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">品质战考核</div>
              <div class="itemNum">￥{{ form.qualityCheckAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">出勤考核</div>
              <div class="itemNum">￥{{ form.attendanceAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">店员补贴扣回</div>
              <div class="itemNum">￥{{ form.staffReduceAmount }}</div>
            </div>
            <el-row class="staffSubsidy">
              <el-col :span="12">车费补贴扣回</el-col>
              <el-col :span="12">{{form.fareReduceAmount}}</el-col>
              <el-col :span="12">体检补贴扣回</el-col>
              <el-col :span="12">{{form.healthCheckReduceAmount}}</el-col>
              <el-col :span="12">工服补贴扣回</el-col>
              <el-col :span="12">{{form.coverallReduceAmount}}</el-col>
              <el-col :span="12">床品补贴扣回</el-col>
              <el-col :span="12">{{form.beddingReduceAmount}}</el-col>
            </el-row>
            <div class="flex-row mb30">
              <div class="itemName">入职补助扣回</div>
              <div class="itemNum">￥{{ form.guaranteeReduceAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>扣发款项</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">合计</div>
              <div class="itemNum">￥{{ form.reduceSubtotal }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">爱心捐款</div>
              <div class="itemNum">￥{{ form.loveDonationAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">社保个人部分</div>
              <div class="itemNum">￥{{ form.socialSecurityAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">旷工考核</div>
              <div class="itemNum">￥{{ form.noAttendanceAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">乐捐</div>
              <div class="itemNum">￥{{ form.voluntarilyDonationAmount }}</div>
            </div>
			<div class="flex-row mb30">
			  <div class="itemName">店员投诉</div>
			  <div class="itemNum">￥{{ form.complainAmount }}</div>
			</div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>备注信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
          </div>
          <div class="drawer-footer ptrb16">
            <el-button @click="back">返回</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "工资详情",
      dialogHide: false,
      form: {
        staffSalaryBaseInfoBo: {},
        staffSalaryCommissionInfoBo: {},
        staffSalaryQualityInfoBo: {},
        staffSalaryReduceInfoBo: {},
        staffSalarySubsidyInfoBo: {},
      },
      dialogHide: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api.post(this.$url.staffSalary.get, {
          staffId: org.staffId,
          reportMonth: org.reportMonth,
          allShopFlag: false
        }).then(res => {
          if (res) {
            this.addEditShow = true;
            this.form = res;
          }
        }).catch(error => {});
      });
    },
    submitAudit (type) {
      this.$api.post(this.$url.attendanceApply.audit, {
        id: this.form.id,
        auditStatus: type
      })
      .then(res => {
        if (res) {
          this.$message.success("审批成功");
          this.addEditShow = false;
          this.$emit("change", true)
        }
      })
    },
    back () {
      this.addEditShow = false;
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.totalAmount {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin: 20px 0 0 0;
  .totalAmount_title {
    display: inline-block;
    width: 120px;
    min-width: 100px;
    padding-left: 24px;
    margin-right: 80px;
  }
}
.staffSubsidy {
    margin-bottom: 30px;
    margin-right: 24px;
    text-align: center;
    border-top: 1px solid #333;
    border-left: 1px solid #333;
    .el-col {
      font-size: 14px;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid #333;
      border-right: 1px solid #333;
    }
  }
</style>